<div class="dynamic-fees-table">
  <div class="p-field p-grid">
    <div class="p-col-12">
      <span class="setting-helper-text">When Shared Offer Sets are enabled, purchase fee configurations must remain consistent across linked accounts.</span>
    </div>
  </div>

  @if (feeRows.length === 0) {
    <div class="p-field p-grid dynamic-fees-table__empty-state">
      <div class="p-col-12">
        No fee rows are configured yet.
      </div>
    </div>
  }

  <div *ngFor="let feeRow of feeRows.controls; let index = index" [formGroup]="feeRow" class="p-fluid p-mb-4 dynamic-fees-table__row">
    <div class="dynamic-fees-table__fields">
      <div class="dynamic-fees-table__field dynamic-fees-table__field--fee-type">
        <label [for]="'fee-type-' + categoryName + '-' + index">Fee Type</label>
        <p-select
          [options]="feeTypeOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="type"
          [inputId]="'fee-type-' + categoryName + '-' + index"
          (onChange)="handleFeeTypeChange(index)">
        </p-select>
        @if (feeRow.get('isDefaultDocumentFee')?.value === true) {
          <small class="dynamic-fees-table__hint">Default document fee row</small>
        }

        @if (isCustomFeeRow(index)) {
          <input
            type="text"
            pInputText
            class="dynamic-fees-table__secondary-input"
            formControlName="customFeeName"
            [id]="'custom-fee-name-' + categoryName + '-' + index"
            aria-label="Custom Fee Name"
            placeholder="Custom fee name">
          @if (feeRow.get('customFeeName')?.invalid && feeRow.get('customFeeName')?.touched) {
            <small class="p-error dynamic-fees-table__error">Custom fee name is required.</small>
          }
        }
      </div>

      <div class="dynamic-fees-table__field">
        <label [for]="'fee-value-' + categoryName + '-' + index">{{getValueLabel(index)}}</label>
        <input
          type="text"
          pInputText
          formControlName="value"
          [id]="'fee-value-' + categoryName + '-' + index">
        <div class="dynamic-fees-table__helper">
          Open-entry amount
        </div>
      </div>

      <div class="dynamic-fees-table__field">
        <label [for]="'purchase-behavior-' + categoryName + '-' + index">Purchase</label>
        <p-select
          [options]="purchaseBehaviorOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="purchaseBehavior"
          [inputId]="'purchase-behavior-' + categoryName + '-' + index"
          (onChange)="handlePurchaseBehaviorChange(index)">
        </p-select>
        <div class="dynamic-fees-table__helper">
          Defines whether the fee already exists in the selling price or should be added.
        </div>

        @if (isPurchaseConfigured(index)) {
          <input
            type="text"
            pInputText
            class="dynamic-fees-table__secondary-input"
            formControlName="purchaseDisplayName"
            [id]="'purchase-display-name-' + categoryName + '-' + index"
            aria-label="Purchase Display Name"
            placeholder="Customer-facing display name">

          <input
            type="text"
            pInputText
            class="dynamic-fees-table__secondary-input"
            formControlName="finalPriceText"
            [id]="'final-price-text-' + categoryName + '-' + index"
            aria-label="Final Price Text"
            placeholder="Final price text">
        }
      </div>

      <div class="dynamic-fees-table__field">
        <label [for]="'lease-behavior-' + categoryName + '-' + index">Lease</label>
        <p-select
          [options]="paymentBehaviorOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="leaseBehavior"
          [inputId]="'lease-behavior-' + categoryName + '-' + index">
        </p-select>
        <div class="dynamic-fees-table__helper">
          Controls how this fee is collected for lease offers.
        </div>
      </div>

      <div class="dynamic-fees-table__field">
        <label [for]="'finance-behavior-' + categoryName + '-' + index">Finance</label>
        <p-select
          [options]="paymentBehaviorOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="financeBehavior"
          [inputId]="'finance-behavior-' + categoryName + '-' + index">
        </p-select>
        <div class="dynamic-fees-table__helper">
          Controls how this fee is collected for finance offers.
        </div>
      </div>

      <div class="dynamic-fees-table__actions">
        @if (canRemoveRow(index)) {
          <button
            type="button"
            pButton
            class="dynamic-fees-table__remove-button"
            label="Remove"
            (click)="removeFeeRow(index)">
          </button>
        }
      </div>
    </div>
  </div>

  <button
    type="button"
    pButton
    label="Add Fee Row"
    icon="pi pi-plus"
    (click)="addFeeRow()">
  </button>
</div>
